export default "__VITE_ASSET__11ca0d09__"